import Vue from "vue";
import License from "@/models/License";
import axios from "axios";

export default class LicenseApi {

    constructor(api) {
        this.api = api;
    }

    download(link) {
        axios.get(link, {responseType: 'blob'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'application/pdf'})
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = "label";
                link.click()
                URL.revokeObjectURL(link.href)
            })
    }

    upload(file, certificateId, callback, error) {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("certificateId", certificateId)
        this.api.getRaw((axios) => {
            axios.post("certificates", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }, () => {
            }).then(() => {
                callback();
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }


    uploadRaw(file, certificateId, name, courseName, date, callback, error) {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("fullName", name);
        formData.append("certificateId", certificateId)
        formData.append("date", date.toISOString())
        formData.append("courseName", courseName)
        this.api.getRaw((axios) => {
            axios.post("certificates/manual", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }, () => {
            }).then(() => {
                callback();
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("license").then((response) => {
                callback(response.data.map((date) => new License(date)));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        });
    }

    getSuperAdmin(companyId, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("license/" + companyId + "?allCourses=true").then((response) => {
                callback(response.data.map((date) => new License(date)));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        });
    }

    setManualCourseValue(companyId, courseId, amount, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("license/" + companyId + "?courseId=" + courseId + "&amount=" + amount).then((response) => {
                callback(new License(response.data));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        });
    }

}
